import React, { useEffect } from 'react';
import { useTitle } from '../hooks/useTitle';
import { LanguageSelector } from '../components/LanguageSelector';
import { AdminBar } from '../components/AdminBar';

export function LegalNotice() {
  const { setTitle } = useTitle();
  
  useEffect(() => {
    setTitle('Mentions légales - Novster AI');
  }, [setTitle]);

  return (
    <div className="min-h-screen bg-white">
      <LanguageSelector />
      <AdminBar />

      <div className="container mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold mb-8">Mentions légales</h1>

        <div className="prose max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">1. Informations légales</h2>
            <p>
              Le site novster.fr est édité par la société Novster, SAS au capital de 10 000 euros,
              immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro XXX XXX XXX.
            </p>
            <p>
              Siège social : [Adresse complète]<br />
              Numéro de TVA intracommunautaire : FR XX XXX XXX XXX<br />
              Directeur de la publication : [Nom du directeur]
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">2. Hébergement</h2>
            <p>
              Le site est hébergé par [Nom de l'hébergeur], [Adresse de l'hébergeur],
              [Numéro de téléphone de l'hébergeur].
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">3. Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de ce site (textes, images, vidéos, etc.) est protégé par le droit
              d'auteur. Toute reproduction, même partielle, est soumise à l'autorisation préalable de
              Novster.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">4. Protection des données personnelles</h2>
            <p>
              Conformément à la loi "Informatique et Libertés" du 6 janvier 1978 modifiée et au
              Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès,
              de rectification, de suppression et d'opposition aux données personnelles vous concernant.
            </p>
            <p>
              Pour exercer ces droits ou pour toute question sur le traitement de vos données,
              vous pouvez nous contacter à l'adresse : [email de contact RGPD]
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">5. Cookies</h2>
            <p>
              Le site utilise des cookies pour améliorer l'expérience utilisateur. En naviguant sur
              ce site, vous acceptez l'utilisation de cookies conformément à notre politique de
              confidentialité.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">6. Liens hypertextes</h2>
            <p>
              Le site peut contenir des liens vers d'autres sites. Novster n'exerce aucun contrôle
              sur ces sites et décline toute responsabilité quant à leur contenu.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">7. Droit applicable</h2>
            <p>
              Les présentes mentions légales sont soumises au droit français. En cas de litige,
              les tribunaux français seront seuls compétents.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}